import React, { useContext, useState } from "react";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";

const CompanyInsert = () => {
  const { cvCategory } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [jwtToken] = useState(localStorage.getItem("jwt") || "");
  const navigate = useNavigate() ;

  
  const workExperience = [
    { id: 0, value: 0, title: t.birildenaz },
    { id: 1, value: 1, title: t.birildenucileqeder },
    { id: 2, value: 2, title: t.ucilden5ileqeder },
    { id: 3, value: 3, title: t.besildencox },
  ];

  const education = [
    { id: 0, value: 0, title: t.ali },
    { id: 1, value: 1, title: t.natamam },
    { id: 2, value: 2, title: t.orta},
  ];

  const workingMode = [
    { id: 0, value: 0, title: t.tamstat },
    { id: 1, value: 1, title: t.yarim },
    { id: 2, value: 2, title: t.frilans },
    { id: 3, value: 3, title: t.tecrubeci },
    { id: 4, value: 4, title: t.uzaqdan },
    { id: 5, value: 5, title: t.muveqqeti },
  ];

  const [inputs, setInputs] = useState({
    category:"",
    vezife: "",
    sheher: "",
    maas_min: "",
    maas_max: "",
    yas_min: "",
    yas_max: "",
    rejim:"",
    texsil_seviyesi: "",
    texrube_seviyesi: "",
    teleb_olunan_bacariqlar: "",
    is_tesviri: "",
    shirket_adi: "",
    elaqedar_shexs: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Şəkili çıxmaq şərti ilə bütün məlumatları JSON obyekt kimi göndəririk
    const dataToSend = {
        kateqoriya_id:inputs.category,
        vezife: inputs.vezife,
        seher: inputs.sheher,
        maas_min: inputs.maas_min,
        maas_max: inputs.maas_max,
        yas_min: inputs.yas_min,
        yas_max: inputs.yas_max,
        rejim:inputs.rejim,
        texsil_seviyesi: inputs.texsil_seviyesi,
        texrube_seviyesi: inputs.texrube_seviyesi,
        teleb_olunan_bacariqlar: inputs.teleb_olunan_bacariqlar,
        is_tesviri: inputs.is_tesviri,
        shirket_adi: inputs.shirket_adi,
        elaqedar_shexs: inputs.elaqedar_shexs,
        email: inputs.email,
    };

    // Axios ilə JSON POST sorğusu göndəririk
    axios
      .post("https://turanozbahceci.com/api/is.php", dataToSend, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        navigate("/resume");
        console.log("sirket elave olundu :",res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-lg-12 col-sm-6 col-12">
            <div>
              <p style={{ marginBottom: "0" }}>
                {t.kateqoriya} <span className="text-danger">*</span>
              </p>
              <select name="category" required id="cvSelect" onChange={handleChange}>
                <option value="" selected disabled>{t.selectcat}</option>
                {cvCategory &&
                
                  cvCategory.map((item) => (
                    <option key={item.id} value={item.id}>
                      {language === "az"
                        ? item.name
                        : language === "en"
                        ? item.name_en
                        : language === "ru"
                        ? item.name_ru
                        : language === "tr"
                        ? item.name_tr
                        : language === "de"
                        ? item.name_de
                        : language === "pl"
                        ? item.name_pl
                        : ""}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-lg-6 col-sm-6 col-12">
            <p>{t.vezife} <span className="text-danger">*</span></p>
            <input type="text"   required placeholder={t.vezife} name="vezife" value={inputs.vezife} onChange={handleChange} />
          </div>

          <div className="col-lg-6 col-sm-6 col-12">
            <p>{t.city} <span className="text-danger">*</span></p>
            <input type="text"   required name="sheher" placeholder={t.city} value={inputs.sheher} onChange={handleChange} />
          </div>

          <div className="col-12">
            <p>{t.maas} <span className="text-danger">*</span></p>
            <div className="row">
              <div className="col-lg-6 col-12">
                <input type="number"   required name="maas_min" placeholder={t.min_maas} value={inputs.maas_min} onChange={handleChange} />
              </div>
              <div className="col-lg-6 col-12">
                <input type="number"   required name="maas_max" placeholder={t.max_maas} value={inputs.maas_max} onChange={handleChange} />
              </div>
            </div>

            <p className="mt-3">{t.old} <span className="text-danger">*</span></p>
            <div className="row">
              <div className="col-lg-6 col-12">
                <input type="number"  required name="yas_min" placeholder="18" value={inputs.yas_min} onChange={handleChange} />
              </div>
              <div className="col-lg-6 col-12">
                <input type="number"  required name="yas_max" placeholder={t.max} value={inputs.yas_max} onChange={handleChange} />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12 col-12">
            <p>{t.education} <span className="text-danger">*</span></p>
            <select name="texsil_seviyesi" required id="cvSelect"  value={inputs.texsil_seviyesi} onChange={handleChange}>
              <option value="" selected disabled>{t.select}</option>
              {education.map((item) => (
                <option key={item} value={item.value}>{item.title}</option>
              ))}
            </select>
          </div>

          <div className="col-lg-6 col-sm-12 col-12">
            <p>{t.istecrubesi} <span className="text-danger">*</span></p>
            <select name="texrube_seviyesi" required id="cvSelect" value={inputs.texrube_seviyesi} onChange={handleChange}>
            <option value="" selected disabled>{t.select}</option>
              {workExperience.map((item) => (
                <option key={item} value={item.value}>{item.title}</option>
              ))}
            </select>
          </div>
          <div className="col-lg-12 col-sm-12 col-12">
            <p>{t.isrejimi} <span className="text-danger">*</span></p>
            <select name="rejim" required id="cvSelect" onChange={handleChange} >
            <option value="" selected disabled>{t.select}</option>
              {workingMode.map((item) => (
                <option key={item} value={item.value}>{item.title}</option>
              ))}
            </select>
          </div>

          <div className="col-12">
            <p>{t.namizedeteleb}</p>
            <textarea name="teleb_olunan_bacariqlar" required placeholder={t.namizedbacariq} value={inputs.teleb_olunan_bacariqlar} onChange={handleChange} />
          </div>

          <div className="col-12">
            <p>{t.isbarede}</p>
            <textarea name="is_tesviri" required  placeholder={t.isinvezifesi} value={inputs.is_tesviri} onChange={handleChange} />
          </div>

          <div className="col-12">
            <p>{t.companyname} <span className="text-danger">*</span></p>
            <input type="text" name="shirket_adi" required placeholder={t.companyname} value={inputs.shirket_adi} onChange={handleChange} />
          </div>

          <div className="col-12">
            <p>{t.elaqedar}<span className="text-danger">*</span></p>
            <input type="text" name="elaqedar_shexs" required placeholder={t.elaqedar} value={inputs.elaqedar_shexs} onChange={handleChange} />
          </div>

          <div className="col-12">
            <p>{t.email} <span className="text-danger">*</span></p>
            <input type="email" name="email" required placeholder={t.email} value={inputs.email} onChange={handleChange} />
          </div>

          <div className="d-flex justify-content-center align-items-center">
            <button type="submit" className="w-100 btn btn-primary">
              {t.yerlesdirin}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default CompanyInsert;
